/*
 * Pure lookups over the parent's player groups. Shared by the account page
 * (contact row → player-details link) and the player page (assessment → player
 * identity), so both read one implementation.
 */
import { IParentPlayerGroup } from '../types';
import { parentPlayerPath } from './parent-links.helpers';

// playerId → the player-details path for its most recent assessment. Rows
// arrive newest-first; a player with no code has no reachable profile.
export const buildPlayerDetailsPaths = (groups: IParentPlayerGroup[]): Record<string, string> => {
  const paths: Record<string, string> = {};

  groups.forEach((group) => group.players.forEach((profile) => {
    const linkable = profile.assessments.find((row) => !!row.code);
    if (linkable && linkable.code) paths[profile._id] = parentPlayerPath(linkable.code, linkable._id);
  }));

  return paths;
};

// The playerId behind a PlayerAssessment this parent can see, or undefined when
// the parent has no claim on it (an anonymous token visitor, say).
export const findPlayerIdByAssessment = (
  groups: IParentPlayerGroup[],
  playerAssessmentId: string,
): string | undefined => groups
  .flatMap((group) => group.players)
  .find((profile) => profile.assessments.some((row) => row._id === playerAssessmentId))?._id;
